import React, { useEffect, useState } from 'react'
import { Row, Col, Card, Carousel, Spin, Button, Tooltip, Modal } from 'antd';
import { WorldTravel } from '../../utils/ImagePath';
import { Link } from 'react-router-dom';
import Seo from '../helmet/Helmet';
import { getFlightOffersList } from '../../services/flight/flightServices';

function Offers() {

    const [sliderOffers, setSliderOffers] = useState([]);
    const [specialOffers, setSpecialOffers] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchOffers = async (offerType, setterFn) => {
        try {
            setLoading(true);
            const response = await getFlightOffersList(offerType);
            setterFn(response?.data || response || []);
        } catch (error) {
            console.error(`Error fetching ${offerType}:`, error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchOffers("slideroffer", setSliderOffers);
        fetchOffers("specialoffer", setSpecialOffers);
    }, []);

    const [expandedOfferId, setExpandedOfferId] = useState(null);
    const toggleOfferVisibility = (id) => {
        setExpandedOfferId((prevId) => (prevId === id ? null : id));
    };

    console.log("specialoffers", specialOffers);


    const [selectedOffer, setSelectedOffer] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openOfferModal = (offer) => {
        setSelectedOffer(offer);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedOffer(null);
    };


    return (
        <>

            <Seo
                title="Special Offers with Extra Discounts – SuperbWorldTrip"
                description="Check out SuperbWorldTrip’s latest travel offers. Save on flight tickets, hotel bookings, and holiday packages. Grab deals before they expire!"
                link="/offers"
                keywords="travel offers, flight discounts, hotel deals, holiday package offers, cheapest travel deals, budget flight offers, affordable hotel booking, discount holiday packages, last-minute travel deals, best travel discounts, exclusive offers SuperbWorldTrip, online travel booking deals"
                largeTwitterCard={true}
                addPostfixTitle={false}
                noIndex={true}
            />

            <section className='offer_banner_area'>
                <div className='container'>
                    <Row gutter={20} className='justify-content-center'>
                        <Col md={18} className='banner_cntr pt-5 text-center' style={{ lineHeight: "0" }}>
                            <div className='banner-content'>
                                <h1 className='mb-0'>Life is Adventure Make The Best of it</h1>
                                <Card className='d-none'>
                                    <div className='d-flex align-items-center gap-3'>
                                        <input type="text" className='form-control' />
                                        <Link className='btn btn-primary'>Search</Link>
                                    </div>
                                </Card>
                            </div>
                            <img loading="lazy" src={WorldTravel} alt='Travel World' className='img-fluid' width={1042} height={415} />
                        </Col>
                    </Row>
                </div>
            </section>

            <section className='offer_area py-5'>
                <div className='container'>
                    <Row gutter={20} className='mb-4'>
                        <Col md={24}>
                            <div className="offer-cntr">
                                <div className="featured-logo">

                                    {loading ? (
                                        <div className="text-center py-5"><Spin size="large" /> </div>
                                    ) : sliderOffers.length > 0 ? (
                                        <Carousel
                                            autoplay
                                            dots={false}
                                            slidesToShow={4}
                                            slidesToScroll={1}
                                            responsive={[
                                                {
                                                    breakpoint: 768,
                                                    settings: {
                                                        slidesToShow: 2,
                                                        slidesToScroll: 1,
                                                    },
                                                },
                                            ]}
                                        >
                                            {sliderOffers?.map((offer, index) => (
                                                <div key={offer.id || index}>
                                                    {/* <div className={`offer-card ${offer.applicable_type_name?.toLowerCase() || ""} background-image text-start mx-2`}> */}
                                                    <img
                                                        src={offer.image_url}
                                                        alt={offer.title || "Offer"}
                                                        className="offer-img"
                                                        height="262"
                                                        width="350"
                                                        loading="eager"
                                                        decoding="async"
                                                    />
                                                    {/* </div> */}
                                                </div>
                                            ))}
                                        </Carousel>
                                    ) : (
                                        null
                                    )}
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <section className="special-offer-section">
                        {loading ? (
                            <>
                                <h2 className='mb-4'>Special Offers</h2>
                                <div className="text-center py-5">
                                    <Spin size="large" />
                                </div>
                            </>
                        ) : (
                            <Row gutter={[20]} className="mb-md-5 mb-2">
                                {specialOffers.map((offer) => (
                                    <Col xs={24} sm={24} md={12} lg={12} key={offer.id}>
                                        <div className="flight_offer mb-4">
                                            <img
                                                loading="lazy"
                                                src={offer.image_url}
                                                alt={offer.title}
                                                className="main-img"
                                            />

                                            <div className="content p-3">
                                                <div className="d-flex align-items-center gap-2 flight_name mb-2">
                                                    <h5 className="bg-primary text-white px-2 py-1 rounded">
                                                        {offer.applicable_type_name}
                                                    </h5>
                                                </div>
                                                <Tooltip title={offer.title}>
                                                    <h3 className="offer-title mb-2">
                                                        {offer.title}
                                                    </h3>
                                                </Tooltip>
                                                
                                            </div>

                                            <div className='d-flex align-items-center justify-content-between pt-0 p-3'>
                                                <Button type="primary" size="middle" onClick={() => openOfferModal(offer)}>
                                                    Know more
                                                </Button>
                                            </div>
                                        </div>
                                    </Col>
                                ))}


                            </Row>
                        )}
                    </section>
                </div>

                <Modal
                    open={isModalOpen}
                    onCancel={closeModal}
                    footer={null}
                    width={800}
                    title={selectedOffer?.title}
                >
                    {selectedOffer && (
                        <>
                            {selectedOffer.avail_offer && (
                                <div
                                    className="mb-3"
                                    dangerouslySetInnerHTML={{
                                        __html: selectedOffer.avail_offer,
                                    }}
                                />
                            )}

                            {selectedOffer.description && (
                                <div
                                    className="mb-3"
                                    dangerouslySetInnerHTML={{
                                        __html: selectedOffer.description,
                                    }}
                                />
                            )}

                            {selectedOffer.offer_detail && (
                                <div
                                    className="mb-3"
                                    dangerouslySetInnerHTML={{
                                        __html: selectedOffer.offer_detail,
                                    }}
                                />
                            )}

                            {selectedOffer.term_condition && (
                                <div
                                    className="mb-3"
                                    dangerouslySetInnerHTML={{
                                        __html: selectedOffer.term_condition,
                                    }}
                                />
                            )}

                            <hr />
                            <h3 className='mt-2'>Customer Support</h3>
                            <ul>
                                <li><b>Email:</b> support@superbworldtrip.com</li>
                                <li><b>Phone:</b> +91-9312241999</li>
                            </ul>
                        </>
                    )}
                </Modal>


            </section>

        </>
    )
}

export default Offers